module.exports = __webpack_public_path__ + "static/img/card.438f4d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/card.png
// module id = qAxK
// module chunks = 1